<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0">
      <Dropdown
        :title="assessorCaption"
        :label="`${$lang.assessor} 1`"
        :value="form.assessor"
        name="assessor"
        id="assessor"
        :vuelidateObj="$v.form.assessor"
        :options="assessorOptions"
        :loading="assessorLoading"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col v-if="hasSecondAssessor" cols="12" class="padding-0">
      <Dropdown
        :title="secondAssessorCaption"
        :label="`${$lang.assessor} 2`"
        :value="form.secondAssessor"
        name="secondAssessor"
        id="secondAssessor"
        :vuelidateObj="$v.form.secondAssessor"
        :options="secondAssessorOptions"
        :loading="secondAssessorLoading"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="flex-end padding-0 margin-top-2">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="handleClose()"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-primary"
        :text="$lang.changeAssessor"
        :loading="loading"
        @click="handleSubmit()"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Dropdown, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { getAssessorCombo } from "@/services";
import { changeAssessor } from "@/modules/kanoon/services";
import { toastAlert } from "@/shared/utils";

export default {
  mixins: [inputMixin],
  inject: ["listWrapperReload"],
  components: { Dropdown, Button },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        assessor: {},
        secondAssessor: {},
      },
    };
  },
  data() {
    return {
      form: {
        assessor: null,
        secondAssessor: null,
      },
      assessorOptions: [],
      assessorLoading: false,
      secondAssessorOptions: [],
      secondAssessorLoading: false,
      loading: false,
    };
  },
  computed: {
    hasSecondAssessor() {
      return pathOr(null, ["second_assessor"], this.item);
    },
    assessorCaption() {
      const assessor = pathOr(null, ["assessor"], this.item);
      const name = pathOr("", ["person", "full_name"], assessor);
      const code = pathOr("", ["person_center_execute_code"], assessor);
      return `${this.$lang.change} ${name} | ${code} ${this.$lang.to}`;
    },
    secondAssessorCaption() {
      const secondAssessor = pathOr(null, ["second_assessor"], this.item);
      const name = pathOr("", ["person", "full_name"], secondAssessor);
      const code = pathOr("", ["person_center_execute_code"], secondAssessor);
      return `${this.$lang.change} ${name} | ${code} ${this.$lang.to}`;
    },
  },
  mounted() {
    Promise.all([this.getAssessorOptions(), this.getSecondAssessorOptions()]);
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    generateComboOptions(options) {
      // generate assessor
      const assessorCode = pathOr(
        null,
        ["assessor", "parvandeh_code"],
        this.item
      );

      // generate second assessor
      const secondAssessorCode = pathOr(
        null,
        ["second_assessor", "parvandeh_code"],
        this.item
      );


      this.assessorOptions = [
        ...options.filter(({ id }) => id !== assessorCode),
      ];
      this.secondAssessorOptions = [
        ...options.filter(({ id }) => id !== secondAssessorCode),
      ];
    },
    async getAssessorOptions() {
      try {
        this.assessorLoading = true;
        const centerExecuteId = pathOr(
          null,
          ["center_execute", "id"],
          this.item
        );
        const assessorCode = pathOr(
          null,
          ["assessor", "person", "code"],
          this.item
        );
        const queryString = { "except_assessor_code[]": assessorCode };
        const response = await getAssessorCombo(centerExecuteId, queryString);
        const { options } = response;
        this.generateComboOptions(options);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessorLoading = false;
      }
    },
    async getSecondAssessorOptions() {
      if (!this.hasSecondAssessor) return;
      try {
        this.secondAssessorLoading = true;
        const centerExecuteId = pathOr(
          null,
          ["center_execute", "id"],
          this.item
        );
        const secondAssessorCode = pathOr(
          null,
          ["second_assessor", "person", "code"],
          this.item
        );
        const queryString = { "except_assessor_code[]": secondAssessorCode };
        const response = await getAssessorCombo(centerExecuteId, queryString);
        const { options } = response;
        this.generateComboOptions(options);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.secondAssessorLoading = false;
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const caseId = pathOr(null, ["id"], this.item);
        const assessorParvandehCode = pathOr(null, ["id"], this.form.assessor);
        const secondAssessorParvandehCode = pathOr(
          null,
          ["id"],
          this.form.secondAssessor
        );
        const response = await changeAssessor(
          caseId,
          assessorParvandehCode,
          secondAssessorParvandehCode
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.listWrapperReload();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
